import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ImportShiftsMutationCgResponse,
  ImportShiftsMutationVariables,
  ValidateShiftsImportMutationCgResponse,
  ValidateShiftsImportMutationVariables,
} from '@common/graphql/schema';

export const ImportShifts: TypedDocumentNode<
  ImportShiftsMutationCgResponse,
  ImportShiftsMutationVariables
> = gql`
  mutation ImportShifts($input: CreateShiftGapImportInput!) {
    createShiftGapImport(input: $input) {
      id
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const ValidateShiftsImport: TypedDocumentNode<
  ValidateShiftsImportMutationCgResponse,
  ValidateShiftsImportMutationVariables
> = gql`
  mutation ValidateShiftsImport($input: ValidateShiftsImportInput!) {
    validateShiftsImport(input: $input) {
      shifts {
        # FIXME: fetch id to help with apollo cache
        # eslint-disable-next-line @graphql-eslint/strict-id-in-types
        unit {
          name
        }
        startDateTime
        endDateTime
        # FIXME: fetch id to help with apollo cache
        # eslint-disable-next-line @graphql-eslint/strict-id-in-types
        role {
          abbreviation
        }
        currentOpenings
        isUpdate
        openingsDiff
        timeZone
      }
      errors {
        row
        type
        field
        message
      }
    }
  }
`;

export type ImportShift = NonNullable<
  ValidateShiftsImportMutationCgResponse['validateShiftsImport']
>['shifts'][number];
